import generateCartItemKey from "../../utils/generateCartItemKey";

// Modifica la acción addToCart para incluir el identificador único
export const addToCart = (item, quantity, selectedExtras, totalPrice) => {
  return async (dispatch, getState) => {
    const state = getState();
    const company = state?.access?.company;
    const uniqueKey = generateCartItemKey(item, selectedExtras, item?.size);

    // if (state.app.pickupMode) {
      item.addedForPickUp = true;
    // }

    dispatch({
      type: "ADD_TO_CART",
      payload: {
        uniqueKey,
        item,
        quantity,
        selectedExtras,
        totalPrice,
        company,
      },
    });
  };
};

// Actualiza la acción removeFromCart para usar el identificador único
export const removeFromCart = (uniqueKey) => {
  return {
    type: "REMOVE_FROM_CART",
    payload: uniqueKey,
  };
};

export const clearCart = () => {
  return {
    type: "CLEAR_CART",
  };
};

export const updateQuantity = (uniqueKey, newQuantity) => {
  return {
    type: "UPDATE_QUANTITY",
    payload: { uniqueKey, newQuantity },
  };
};

// Si necesitas actualizar un item en el carrito, también deberías usar el identificador único
// export const updateCartItem = (uniqueKey, updatedItem) => {
//   return { type: "UPDATE_CART_ITEM", payload: { uniqueKey, updatedItem } };
// };

export const getInternalCart = () => {
  return async (dispatch, getState) => {
    try {
      const cartRawData = localStorage.getItem('@cart');
      const cart = cartRawData ? JSON.parse(cartRawData) : [];

      dispatch({
        type: 'SET_CART',
        payload: cart?.filter(entity=>entity?.item?.addedForPickUp),
      });
    } catch (error) {
      console.error("Error al recuperar el carrito:", error);
      dispatch({
        type: 'SET_CART',
        payload: [], // fallback vacío
      });
    }
  };
};